import * as React from "react";
import moment from "moment";
import { Page, DataTable, Spinner, ModalOverlay } from "src/components/common";
import ClientAPI from "./ClientAPI";
import PickListContext from "src/context/pickListContext";
import CustomFieldInfo from "src/components/forms/CustomFieldInfo";
import ClientResultsTable from "src/components/forms/ClientResultsTable";
import DatasetAPI from "src/admin/Organization/Datasets/DatasetAPI";

interface IProps {
	history?: any;
	match?: any;
	customFields: CustomFieldDTO[];
	location?: any;
	api?: any;
	currentUser?: any;
}

interface IState {
	client: ClientDTO;
	datasets: DatasetDTO[];
	isLoading: boolean;
}

class ClientResults extends React.Component<IProps, IState> {
	public static contextType = PickListContext;

	constructor(props: IProps) {
		super(props);
		this.state = {
			datasets: [],
			client: {},
			isLoading: true,
		};
	}

	public componentDidMount() {
		const { clientId, organizationId, datasetId } = this.props.match.params;

		const p_client = ClientAPI.getClientSiteClient({ datasetId, clientId });

		// fetch datasets based on org id
		const p_datasets = DatasetAPI.getClientSiteOrgniazationDatasetsForClient(
			organizationId,
			clientId,
			"userCount"
		);

		Promise.all([p_client, p_datasets])
			.then((values) => {
				const [client, datasets] = values;

				//Sort Datasets so current dataset is first in the list
				const currentDatasetId = +this.props.match.params.datasetId;
				let sortedDatasets: DatasetDTO[] = [];
				sortedDatasets.push(
					datasets.find((x) => {
						return x.id === currentDatasetId;
					})!
				);
				sortedDatasets.push(
					...datasets.filter((x) => x.id !== currentDatasetId)
				);

				this.setState({
					client: client,
					datasets: sortedDatasets,
				});
			})
			.finally(() => this.setState({ isLoading: false }));
	}

	public render() {
		const { clientId, organizationId, datasetId } = this.props.match.params;

		return this.context.pickListItems.length > 0 &&
			this.state.isLoading !== false ? (
			<Spinner />
		) : (
			<Page title="Client Test Results">
				<div className="container-fluid">
					<div className="row">
						<div className="col">
							<p className="d-inline-block mr-3">
								<span className="font-weight-bold">Participant Code:</span>
								&nbsp;
								{this.state.client.clientCode}
							</p>
							<p className="d-inline-block mr-3">
								<span className="font-weight-bold">Name:</span>&nbsp;
								{this.state.client.firstName} {this.state.client.lastName}
							</p>
							<p className="d-inline-block mr-3">
								<span className="font-weight-bold">Birth Year:</span>&nbsp;
								{this.state.client.birthYear}
							</p>
							{this.state.client.employeeId ? (
								<p className="d-inline-block mr-3">
									<span className="font-weight-bold">Employee Id:</span>
									&nbsp;
									{this.state.client.employeeId}
								</p>
							) : null}
							<p className="d-inline-block mr-3">
								<span className="font-weight-bold">Created:</span>&nbsp;
								{moment
									.utc(this.state.client.createdDate)
									.local()
									.format("MMM DD, YYYY")}
							</p>
							<p className="d-inline-block mr-3">
								<span className="font-weight-bold">Status:</span>&nbsp;
								{this.state.client.isActive ? (
									<span>Active</span>
								) : (
									<span>InActive</span>
								)}
							</p>
							<CustomFieldInfo
								customFieldValues={this.state.client.customFieldValues!}
							/>
						</div>
					</div>

					{this.state.datasets.map((dataset) => {
						return (
							<ClientResultsTable
								key={dataset.id}
								history={this.props.history}
								location={this.props.location}
								clientId={clientId}
								organizationId={organizationId}
								datasetId={dataset.id!}
								currentUser={this.props.currentUser}
								api={this.props.api}
							/>
						);
					})}
				</div>
			</Page>
		);
	}
}

export default ClientResults;
